export const BREADCRUMBS_MAX_VISIBLE_PATH_SEGMENTS = 2;

export const NOT_FOUND_ICON_PRIMARY_BACKGROUND_ALPHA = 0.2;

export const MENU_TRANSITION_FADE_ENTER_DURATION_MS = 300;
export const MENU_TRANSITION_STANDARD_DURATION_MS = 150;
